// Full-viewport hero header for internal pages with cinematic video background.

const HERO_INNER_VIDEO = "https://customer-assets.emergentagent.com/job_beauty-tech-premium/artifacts/jdbitsvj_vecteezy_a-woman-with-a-beautiful-face-and-long-hair_70694890.mp4";

export default function PageHero({ overline, title, highlight, titleAfter, subtitle, align = "left", testid }) {
  return (
    <section
      data-testid={testid || "page-hero"}
      className="dark-section relative overflow-hidden -mt-20 h-screen min-h-[640px] flex items-end"
    >
      <div className="absolute inset-0 bg-[#0a0a0c]"/>
      <video
        autoPlay loop muted playsInline
        className="absolute inset-0 w-full h-full object-cover opacity-70"
        aria-hidden="true"
      >
        <source src={HERO_INNER_VIDEO} type="video/mp4" />
      </video>
      {/* Subtle bottom fade into cream + ambient orange highlight */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0c]/60 via-transparent to-[#f7ebd9] pointer-events-none"/>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(255,156,0,0.22),transparent_55%)] pointer-events-none"/>

      <div className={`relative max-w-7xl mx-auto px-6 md:px-12 pb-28 md:pb-36 w-full ${align === "center" ? "text-center" : ""}`}>
        {overline && <p className="overline">{overline}</p>}
        <h1 className={`font-heading text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-extrabold tracking-tighter mt-6 leading-[0.95] ${align === "center" ? "mx-auto" : ""} max-w-5xl ink-heading`}>
          {title}
          {highlight && <> <span className="text-white">{highlight}</span></>}
          {titleAfter && <> {titleAfter}</>}
        </h1>
        {subtitle && (
          <p className={`mt-8 text-lg md:text-xl text-white/85 leading-relaxed max-w-3xl ${align === "center" ? "mx-auto" : ""}`}>
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
